import React, { useEffect, useRef, useState } from 'react';
import Device from 'mobile-detect';
import tooltipIcon from 'assets/icons/icon-tooltip.svg';
import { useEventListener } from 'hooks/useEventListener';
import { useOutsideAlerter } from 'hooks/useOutsideAlerter';

const InfoTooltip = ({ triggerEvent, text, style, addClass, newClassName, icon, alt, children }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [position, setPosition] = useState('');
    const tooltipBoxRef = useRef();
    const tooltipTextRef = useRef();

    useEffect(() => {
        handleResize();
    }, []);

    useOutsideAlerter(tooltipBoxRef, () => {
        resetTooltipState();
    });

    useEffect(() => {
        showTooltip
            ? window.addEventListener('scroll', scrollAction)
            : window.removeEventListener('scroll', scrollAction);
    }, [showTooltip]);

    const resetTooltipState = () => {
        setShowTooltip(false);
        tooltipTextRef.current.style.bottom = '35px';
    };

    const handleClick = () => {
        if (showTooltip) {
            resetTooltipState();

            return;
        }

        setShowTooltip(true);

        if (getTooltipPosition().top < 0) {
            const height = tooltipTextRef.current.clientHeight;
            tooltipTextRef.current.style.bottom = `-${height + 18}px`;
        }

        if (triggerEvent) {
            triggerEvent();
        }
    };

    const handleResize = () => {
        setShowTooltip(false);

        const md = new Device(navigator.userAgent);
        const text = tooltipTextRef.current;
        let element = tooltipBoxRef.current;

        let left = 0;
        while (element) {
            left = left + parseInt(element.offsetLeft);
            element = element.offsetParent;
        }

        if (md.phone() != null) {
            text.style.width = `${screen.width - 40}px`;
            text.style.left = `-${left - 20}px`;
        } else {
            text.style.width = null;
            text.style.left = null;
        }
    };

    const getTooltipPosition = () => {
        let newPos = {};
        if (tooltipTextRef.current) {
            const pos = tooltipTextRef.current.getBoundingClientRect();
            const top = pos.top - 80; // 80 is the height of the header
            newPos = {
                top,
                bottom: pos.bottom,
            };

            if (top < 0) {
                setPosition('down');
            } else {
                setPosition('up');
            }
        }

        return newPos;
    };

    const scrollAction = () => {
        if (showTooltip) {
            if (getTooltipPosition().top > 0) {
                tooltipTextRef.current.style.bottom = '35px';
            }
            if (getTooltipPosition().top < 0) {
                const height = tooltipTextRef.current.clientHeight;
                tooltipTextRef.current.style.bottom = `-${height + 18}px`;
            }
        }
    };

    const newClass = newClassName !== '' ? `form__info-tooltip__${newClassName} ` : '';
    const classTooltip = `${newClass}form__info-tooltip__popup ${
        showTooltip ? '' : 'form__info-tooltip__popup--hidden'
    }`;
    const classHelp = `help ${showTooltip ? 'help__show-arrow ' : ''}`;
    const classHelpDiv = showTooltip && 'help__show-arrow';
    const classArrowPos = position === 'down' ? 'up' : 'down';
    const className = `form__info-tooltip ${addClass}`;

    useEventListener('resize', handleResize);
    useEventListener('orientationchange', handleResize);

    return (
        <div ref={tooltipBoxRef} className={className} style={style}>
            {icon && (
                <span className={classHelp} onClick={handleClick}>
                    <div className={classArrowPos}></div>
                    <img src={icon} alt={alt ?? 'info-tooltip'} />
                </span>
            )}
            {children && (
                <div className={classHelpDiv} onClick={handleClick}>
                    <div className={classArrowPos}></div>
                    {children}
                </div>
            )}

            <div ref={tooltipTextRef} className={classTooltip}>
                {text}
            </div>
        </div>
    );
};

InfoTooltip.defaultProps = {
    text: '',
    style: {},
    addClass: '',
    newClassName: '',
    triggerEvent: null,
    icon: tooltipIcon,
};

module.exports = InfoTooltip;
